import gql from 'graphql-tag'

export const GET_PRODUCTSET_LIST = gql`
  query(
    $ids: [ID!]
    $page: Int
    $perPage: Int
    $search: String
    $shopee: Boolean
    $sort: ProductSetResolverOrderBy
    $stockId: ID
  ) {
    productSetList(
      ids: $ids
      page: $page
      perPage: $perPage
      search: $search
      shopee: $shopee
      sort: $sort
      stockId: $stockId
    ) {
      hasNextPage
      nodesCount
      pagesCount
      nodes {
        id
        name
        price
        code
        thumbUrl
        pictureUrl
        available
      }
    }
  }
`

export default {
  GET_PRODUCTSET_LIST
}
